export const ARABIC_WEEKDAYS = ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'];

export const ARABIC_LANGUAGE = 'ar';
